import React, { useEffect } from "react";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { SingleSelect } from "react-select-material-ui";
import useLanguageQuery from '../../graphql/queries/change-language';
import useThemeQuery from '../../graphql/queries/toggle-theme';

const useStyles = makeStyles({
    select: {
      borderRadius: 8
    },
    selectWidth: {
      width: 100, 
    },
    selectDark: {
      backgroundColor: '#19314a' ,
    },
    selectLight: {
        backgroundColor: '#F5F6FA' ,
    },
});

const styles = dark => ({
    control: (base, state) => ({
      ...base,
      background: 'transparent',
      borderBottomWidth: 0,
      borderBottomStyle: 'solid',
      borderLeftWidth: 0,
      borderRightWidth: 0,
      borderTopWidth: 0,
      borderRadius: 0,
      boxShadow: 'none',
      marginRight: 25
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: '#6f809b',
      '&:hover': { color: '#2592EA' }
    }),
    menuList: (base) => ({
      ...base,
      backgroundColor: dark ? '#123456': '#F5F6FA',
      color: '#ffffff',
      // borderBottomLeftRadius: 8,
      // borderBottomRightRadius: 8,
      marginTop: -7,
    }),
    option: (base, { isSelected }) => ({
      ...base,
      backgroundColor: dark? '#19314a': '#F5F6FA',
      color: isSelected ? '#2592EA' : '#6f809b',
      '&:hover': { backgroundColor: dark ? '#234567':'#E5E5E9', color: isSelected ? '#2592EA' : dark ? '#fff': '#6f809b'}
    }),
    singleValue: (base) => ({
      ...base,
      color: '#6f809b', 
      paddingLeft: 5,
      paddingRight: 5,
    })
});

const SelectLanguage = ({ fullWidth }) => {
    const classes = useStyles();
    const { data: theme } = useThemeQuery();
    const { client, data } = useLanguageQuery();
    const options = ["EN", "FR"];

    useEffect(() => {
      localStorage.setItem("lang", localStorage.getItem("lang"));
    });

    const handleChange = value => {
        localStorage.setItem('lang', value);
        client.writeData({ data : { language: { language: value, __typename: 'Language'} }});
    }; 

    return (
      <div>
        <SingleSelect 
          className={clsx(
            classes.select, 
            theme && theme.theme ? classes.selectDark: classes.selectLight,
            !fullWidth? classes.selectWidth: ''
          )} 
          value={data.language.language} 
          options={options} 
          onChange={handleChange}
          fullWidth={fullWidth}
          SelectProps={{styles: styles(theme && theme.theme)}} 
        />
      </div>
    );
 }

export default SelectLanguage;
